import { Link } from "react-router-dom";
import "./CompanyDetails.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Avatar from "@mui/material/Avatar";
import { useCallback, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { IoCameraSharp } from "react-icons/io5";
import { MdBusiness, MdLocationOn, MdPhone } from "react-icons/md";
import { FaIdCard, FaHashtag } from "react-icons/fa";
import { HiOfficeBuilding } from "react-icons/hi";
import ButtonCom from "../../../components/button/button";
import { useDispatch, useSelector } from "react-redux";
import { updateUserData } from "../../../services/commonServices";
import {
  commonGetData,
  commonGetDataOne,
  commonSaveData,
  initState,
} from "../../../redux/slices/commonSlice";
import { Col, Form, Row } from "react-bootstrap";
import {
  fetchBusinessTypeListPath,
  updateCompanyDetailsPath,
  UpdateCompanyLogoPath,
  getCompanyProfileListPath,
} from "../../../services/config";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import { useGlobalToast } from "../../../stopOldToastGlobally.js";

const CompanyDetails = () => {
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);
  const themeStore = useSelector((state) => state.theme);
  const isDark = themeStore?.theme === "dark" || !themeStore?.theme;
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
const toast = useGlobalToast();
  const [business, setBusiness] = useState([]);
  const [userDetail, setUserDetail] = useState({});

  const [addStaff, setAddStaff] = useState({
    cmp_logo: "",
    cmp_name: "",
    business_type: "",
    cmp_address: "",
    gst_number: "",
    urn_number: "",
    cmp_mobile: "",
  });

  // Professional Theme
  const theme = {
    bg: isDark ? "#0f0f23" : "#f5f7fa",
    card: isDark ? "#1a1a2e" : "#ffffff",
    cardSecondary: isDark ? "#16213e" : "#f8fafc",
    text: isDark ? "#ffffff" : "#1a202c",
    lightText: isDark ? "#e2e8f0" : "#2d3748",
    border: isDark ? "#2d2d44" : "#e2e8f0",
    muted: isDark ? "#94a3b8" : "#64748b",
    accent: isDark ? "#6366f1" : "#4f46e5",
    accentHover: isDark ? "#818cf8" : "#4338ca",
    gradient: isDark 
      ? "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)"
      : "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
    success: "#10b981",
    cardShadow: isDark
      ? "0 4px 6px -1px rgba(0, 0, 0, 0.3)"
      : "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
  };

  const getBusiness = useCallback(() => {
    dispatch(commonGetData(`${fetchBusinessTypeListPath}${user.user_id}`));
    dispatch(commonGetDataOne(`${getCompanyProfileListPath}${user.user_id}`));
  }, [dispatch, user.user_id]);

  useEffect(() => {
    getBusiness();
  }, [getBusiness]);

  useEffect(() => {
    if (commonState.commonGetSuccess) {
      setBusiness(commonState.commonGetData);
    }
    if (commonState.commonGetOneSuccess) {
      const data = commonState.commonGetOneData[0];
      setUserDetail(data);
      setAddStaff((prev) => ({
        ...prev,
        cmp_logo: data.cmp_logo,
        cmp_name: data.cmp_name,
        business_type: data.business_type,
        cmp_address: data.cmp_address,
        gst_number: data.gst_number,
        urn_number: data.urn_number,
        cmp_mobile: data.cmp_mobile,
      }));
    }
  }, [commonState]);

  const inputsTwo = [
    {
      name: "cmp_name",
      label: "Company Name",
      placeholder: "Enter Company Name",
      icon: <MdBusiness />,
      required: true,
    },
    {
      name: "business_type",
      label: "Business Type",
      chi: business,
      icon: <HiOfficeBuilding />,
      required: true,
    },
    {
      name: "gst_number",
      label: "GST Number",
      placeholder: "Enter GST Number",
      icon: <FaIdCard />,
      isReadOnly: true,
    },
    {
      name: "urn_number",
      label: "Udyam Registration Number",
      placeholder: "Enter URN Number",
      icon: <FaHashtag />,
    },
    {
      name: "cmp_address",
      label: "Company Address",
      placeholder: "Enter Company Address",
      icon: <MdLocationOn />,
      isTextarea: true,
    },
  ];

  const handelChange = (e) => {
    const { name, value } = e.target;
    setAddStaff((pv) => ({ ...pv, [name]: value }));
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("cmp_name", addStaff.cmp_name);
    let d = {
      path: updateCompanyDetailsPath,
      data: {
        userId: user.user_id,
        cmp_name: addStaff.cmp_name,
        business_type: addStaff.business_type,
        cmp_address: addStaff.cmp_address,
        gst_number: addStaff.gst_number,
        urn_number: addStaff.urn_number,
      },
    };
    dispatch(commonSaveData(d));
  };

  const [isFile, setIsFile] = useState(false);
  const [cmp_logo, setCmpLogo] = useState("");

  const fileHandle = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      toast.error('Please select an image file');
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (event) {
      const base64 = event.target.result;
      setCmpLogo(base64);
      setIsFile(true);
    };
  };

  const updateLogo = () => {
    if (cmp_logo) {
      let d = {
        path: UpdateCompanyLogoPath,
        data: {
          userId: user.user_id,
          cmp_logo,
        },
      };
      dispatch(commonSaveData(d));
    }
  };

  useEffect(() => {
    if (commonState.commonSuccess) {
      if (cmp_logo) {
        updateUserData({ company_logo: cmp_logo });
        setCmpLogo("");
      }
      if (localStorage.getItem("cmp_name")) {
        const company_name = localStorage.getItem("cmp_name");
        updateUserData({ company_name: company_name });
        localStorage.removeItem("cmp_name");
      }
      dispatch(commonGetDataOne(`${getCompanyProfileListPath}${user.user_id}`));
      toast.success(commonState.commonMessage);
      dispatch(initState());
      setIsFile(false);
    }
    if (commonState.commonError) {
      toast.error(commonState.commonMessage);
      dispatch(initState());
    }
  }, [commonState, cmp_logo, dispatch, user.user_id]);

  const takeFile = () => {
    document.getElementById("fileId").click();
  };

  return (
    <div
      className="SettingBody"
      style={{
        position: "fixed",
        width: "100%",
        height: "100%",
        borderRadius: "7px",
        overflow: "auto",
        backgroundColor: theme.bg,
      }}
    >
      <ToastContainer position="top-right" autoClose={2000} className="toast-custom" />

      <Widgets
        icon={
          <WidgetsIcon
            icon={
              <Link to="/setting/">
                <ArrowBackIcon className="icon-color" />
              </Link>
            }
            title="Company Details"
          />
        }
        button={
          <ButtonCom
            type="button"
            class_name={"p_btn universal-btn"}
            text={
              commonState.commonLoading
                ? "Updating..."
                : isFile
                ? "Update Logo"
                : "Update Details"
            }
            url_or_onclick={isFile ? updateLogo : handelSubmit}
            icon={null}
            width={""}
          />
        }
        body={
          <div style={{ padding: "24px", maxWidth: "1200px", margin: "0 auto" }}>
            {/* Profile Card */}
            <div
              style={{
                background: theme.card,
                borderRadius: "20px",
                padding: "40px",
                marginBottom: "24px",
                boxShadow: theme.cardShadow,
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Gradient Background */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "120px",
                  background: theme.gradient,
                  opacity: 0.1,
                }}
              />

              <div style={{ 
                position: "relative", 
                display: "flex", 
                flexDirection: "column", 
                alignItems: "center",
                textAlign: "center" 
              }}>
                {/* Logo Upload */}
                <Form encType="multipart/form-data">
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={fileHandle}
                    style={{ display: "none" }}
                    id="fileId"
                  />
                </Form>

                <div style={{ position: "relative", marginBottom: "20px" }}>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      cursor: "pointer",
                    }}
                    onClick={takeFile}
                  >
                    <Avatar
                      alt={addStaff.cmp_name || user.company_name}
                      src={
                        cmp_logo
                          ? cmp_logo
                          : user.company_logo
                          ? user.company_logo
                          : "/static/images/avatar/1.jpg"
                      }
                      sx={{ 
                        width: 120, 
                        height: 120,
                        border: `4px solid ${theme.card}`,
                        boxShadow: theme.cardShadow,
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        bottom: "5px",
                        right: "5px",
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        background: theme.gradient,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                        transition: "transform 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                    >
                      <IoCameraSharp style={{ color: "#fff", fontSize: "18px" }} />
                    </div>
                  </div>
                </div>

                {/* Company Name */}
                <h2
                  style={{
                    color: theme.text,
                    fontSize: "28px",
                    fontWeight: "700",
                    marginBottom: "8px",
                  }}
                >
                  {addStaff.cmp_name || user.company_name || "Company Name"}
                </h2>

                {/* Company Code */}
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 20px",
                    borderRadius: "20px",
                    background: isDark ? "rgba(99, 102, 241, 0.15)" : "rgba(79, 70, 229, 0.1)",
                    marginBottom: "12px",
                  }}
                >
                  <span style={{ fontSize: "14px", fontWeight: "600", color: theme.accent }}>
                    Company Code:
                  </span>
                  <span style={{ fontSize: "14px", fontWeight: "700", color: theme.accent }}>
                    IMKQM
                  </span>
                </div>

                {/* Subtitle */}
                <p style={{ color: theme.muted, fontSize: "14px", margin: 0 }}>
                  Edit your company details and keep your profile up to date
                </p>
              </div>
            </div>

            {/* Form Card */}
            <div
              style={{
                background: theme.card,
                borderRadius: "20px",
                padding: "32px",
                boxShadow: theme.cardShadow,
              }}
            >
              <h3
                style={{
                  color: theme.text,
                  fontSize: "20px",
                  fontWeight: "700",
                  marginBottom: "24px",
                }}
              >
                Company Information
              </h3>

              <Form>
                <Row>
                  {inputsTwo.map((item, i) => (
                    <Col sm="6" className="mb-4" key={i}>
                      <Form.Group>
                        <Form.Label
                          style={{
                            color: theme.text,
                            fontWeight: "600",
                            fontSize: "14px",
                            marginBottom: "10px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span
                            style={{
                              color: theme.accent,
                              fontSize: "18px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {item.icon}
                          </span>
                          {item.label}
                          {item.required && (
                            <span style={{ color: "#ef4444" }}>*</span>
                          )}
                        </Form.Label>

                        {item.chi ? (
                          <div style={{ position: "relative" }}>
                            <Form.Select
                              name={item.name}
                              value={addStaff[item.name]}
                              onChange={handelChange}
                              required={item.required}
                              style={{
                                padding: "12px 16px 12px 16px",
                                borderRadius: "12px",
                                border: `2px solid ${theme.border}`,
                                backgroundColor: isDark ? "#0f0f23" : "#ffffff",
                                color: theme.text,
                                fontSize: "14px",
                                cursor: "pointer",
                                appearance: "none",
                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='${isDark ? '%23ffffff' : '%2394a3b8'}' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "right 14px center",
                              }}
                            >
                              <option value="">Select Business Type</option>
                              {item.chi.map((dv, i) => (
                                <option key={i} value={dv.businessTypeId}>
                                  {dv.type_name}
                                </option>
                              ))}
                            </Form.Select>
                          </div>
                        ) : item.isTextarea ? (
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name={item.name}
                            value={addStaff[item.name]}
                            placeholder={item.placeholder}
                            onChange={handelChange}
                            readOnly={item.isReadOnly}
                            style={{
                              padding: "12px 16px",
                              borderRadius: "12px",
                              border: `2px solid ${theme.border}`,
                              backgroundColor: isDark ? "#0f0f23" : "#ffffff",
                              color: theme.text,
                              fontSize: "14px",
                              resize: "vertical",
                            }}
                          />
                        ) : (
                          <Form.Control
                            name={item.name}
                            type="text"
                            value={addStaff[item.name]}
                            placeholder={item.placeholder}
                            onChange={handelChange}
                            readOnly={item.isReadOnly}
                            required={item.required}
                            style={{
                              padding: "12px 16px",
                              borderRadius: "12px",
                              border: `2px solid ${theme.border}`,
                              backgroundColor: isDark ? "#0f0f23" : "#ffffff",
                              color: theme.text,
                              fontSize: "14px",
                            }}
                          />
                        )}
                      </Form.Group>
                    </Col>
                  ))}
                </Row>
              </Form>

              {/* Info Box */}
              <div
                style={{
                  marginTop: "24px",
                  padding: "16px 20px",
                  borderRadius: "12px",
                  background: isDark ? "rgba(99, 102, 241, 0.1)" : "rgba(79, 70, 229, 0.05)",
                  border: `1px solid ${isDark ? "rgba(99, 102, 241, 0.2)" : "rgba(79, 70, 229, 0.1)"}`,
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <span style={{ fontSize: "20px" }}>💡</span>
                <span style={{ color: theme.muted, fontSize: "14px" }}>
                  Your company details are used across the platform. Keep them updated for better experience.
                </span>
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default CompanyDetails;